export class NoopAction {
  public static readonly type = '[App] Noop';
}
